<div style="overflow: hidden">
  <div class="flex-fill d-flex flex-column">
    <div class="modal-container">
      <div class="page-header title-margin">Create Team</div>
      <button type="button" mat-icon-button aria-label="Close" class="close-x-btn" (click)="cancel()"
        style="position: absolute; top: 10px; right: 10px;">
        <mat-icon>close</mat-icon>
      </button>
      <div>
        <form [formGroup]="teamForm" style="min-height: 750px">

          <mat-horizontal-stepper linear #stepper labelPosition="right" style="background-color: unset;">
            <mat-step id="step1" label="Set up team">
              <div class="step">
                <div class="form-fields-container">
                  <mat-form-field class="full-width form-field-container" *ngIf="clients && clients.length > 1">
                    <mat-label>Client</mat-label>
                    <mat-select formControlName='clientId'>
                      <mat-option *ngFor="let client of clients" [value]="client.id">
                        {{ client.name }}
                      </mat-option>
                    </mat-select>
                    <mat-error *ngIf="teamForm.get('clientId').hasError('required')">
                      <small>Required</small>
                    </mat-error>
                  </mat-form-field>
                  <mat-form-field class="full-width form-field-container">
                    <mat-label>Team Name</mat-label>
                    <input matInput formControlName='teamName'>
                    <mat-error *ngIf="teamForm.get('teamName').hasError('required') || teamForm.get('teamName').hasError('whiteSpace')">
                      <small>Required</small>
                    </mat-error>
                    <mat-error *ngIf="teamForm.get('teamName').hasError('maxlength')">
                      <small>Maximum 50 characters allowed</small>
                    </mat-error>
                    <mat-error *ngIf="teamForm.get('teamName').hasError('duplicate')">
                      <small>Team name already exists</small>
                    </mat-error>
                  </mat-form-field>
                </div>
              </div>
            </mat-step>
            <mat-step id="step2" label="Add Admins" [stepControl]="teamForm.get('adminUsers')">
              <div class="step">
                <div style="padding: 8px;">
                  <users-selection-table [users]="adminUserList" label="Users" [selectedUsers]="[]"
                    [showError]="teamForm.get('adminUsers').hasError('required')"
                    (selectionChange)="onAdminSelectionChange($event)">
                  </users-selection-table>
                </div>
              </div>
            </mat-step>
            <mat-step id="step3" label="Add Users" [stepControl]="teamForm.get('teamMembers')">
              <div class="step">
                <div style="padding: 8px;">
                  <users-selection-table [users]="teamMemberList" label="Users" [selectedUsers]="[]"
                    [showError]="teamForm.get('teamMembers').hasError('required')"
                    (selectionChange)="onTeamMemberSelectionChange($event)">
                  </users-selection-table>
                </div>
              </div>
            </mat-step>
          </mat-horizontal-stepper>
        </form>
      </div>
    </div>
    <div class="close-box">
      <ng-container *ngIf="stepper?.selectedIndex === 0">
        <button class="cancel-btn" type="button" mat-button color="primary" (click)="cancel()">
          CANCEL
        </button>
        <mrs-btn-primary buttonLabel="Next" buttonId="nextButton" (onClick)="stepper.next()"
          [disabled]="!(teamForm.get('clientId').valid && teamForm.get('teamName').valid)">
        </mrs-btn-primary>
      </ng-container>

      <ng-container *ngIf="stepper?.selectedIndex === 1">
        <button class="prev-btn" type="button" mat-button color="primary" (click)="stepper.previous()">
          PREVIOUS
        </button>
        <mrs-btn-primary buttonLabel="Next" buttonId="nextButton" (onClick)="onStep2Next()"
          [disabled]="!(teamForm.get('adminUsers').valid)">
        </mrs-btn-primary>
      </ng-container>

      <ng-container *ngIf="stepper?.selectedIndex === 2">
        <button class="prev-btn" type="button" mat-button color="primary" (click)="stepper.previous()">
          PREVIOUS
        </button>
        <mrs-btn-primary buttonLabel="Save Changes" buttonId="saveCloseButton" (onClick)="saveAndClose()"
          [disabled]="!teamForm.valid">
        </mrs-btn-primary>
      </ng-container>
    </div>
  </div>